export enum InHouseFilterEnum {
  only = 'only',
  all = 'all',
  exclude = 'exclude',
}

export const InHouseFilterLabels = {
  [InHouseFilterEnum.only]: 'Only',
  [InHouseFilterEnum.all]: 'All',
  [InHouseFilterEnum.exclude]: 'Exclude',
};

export const FilterInHouseButtonItems = [
  {
    text: InHouseFilterLabels[InHouseFilterEnum.only],
    value: InHouseFilterEnum.only,
    btnText: `In-House Only`,
  },
  {
    text: InHouseFilterLabels[InHouseFilterEnum.all],
    value: InHouseFilterEnum.all,
  },
  {
    text: InHouseFilterLabels[InHouseFilterEnum.exclude],
    value: InHouseFilterEnum.exclude,
    btnText: `Exclude In-House`,
  }
];
